<template lang="pug">
BlueSearch
	template(#header="{}")
		SearchQuery
			template(#default="{results, query, setQuery, sort, setSort, executeSearch, currentResultsStart, currentResultsEnd}")
				myQuery(
					:results="results",
					:executeSearch="executeSearch",
					:setQuery="setQuery",
					:query="query",
				)
	template(#main="{}")
		.search__main
			SearchResults
				template(#item="result")
					myResult(
						:result="result"
					)
	template(#footer="{}")
		.search__footer
			SearchPagination
				template(
					#default="{ totalPages, currentPage, enablePrev, enableNext, navigate }"
				)
					myPagination(
						:totalPages="totalPages",
						:currentPage="currentPage",
						:enablePrev="enablePrev",
						:enableNext="enableNext",
						:navigate="navigate",
					)
</template>

<script>
import myQuery from './components/Query';
import myResult from './components/Result';
import myPagination from './components/Pagination';

export default {
	name: "SearchApp",
	components: {
		myQuery,
		myResult,
		myPagination,
	}
};
</script>

<style lang="scss">
	
// All possible CSS variable overrides
#bluesearch {
	--font-size: /* property value */;
	--font-weight: /* property value */;
	--font-family: /* property value */;
	--line-height: /* property value */;
	--color: #{$darkGray};

	--link-color: #{$blue} /* property value */;
	--link-hover-color: #{$blue}/* property value */;
	--link-transition: all 0.25s ease-in-out;

	--loader-color: #{$green}/* property value */;

	--accordion-title-color: /* property value */;
	--accordion-title-active-color: /* property value */;
	--accordion-title-transition: /* property value */;

	--border-color: #{$mediumGray} /* property value */;

	--label-color: /* property value */;
	--label-background: /* property value */;

	--button-color: #{$buttonSecondaryColor} /* property value */;
	--button-background: #{$buttonSecondaryBackground} /* property value */;
	--button-hover-color: #{$buttonSecondaryColorHover} /* property value */;
	--button-hover-background: #{$buttonSecondaryBackgroundHover}/* property value */;
	--button-transition: background-color .25s ease-out, color .25s ease-out; /* property value */;

	--check-background: /* property value */;
	--check-border: /* property value */;
	--check-active-color: #{$white} /* property value */;
	--check-active-background: #{$blue} /* property value */;
	--check-active-border: /* property value */;
	--check-transition: /* property value */;

	--tag-color: /* property value */;
	--tag-background: /* property value */;
	--tag-hover-color: /* property value */;
	--tag-hover-background: /* property value */;
	--tag-transition: /* property value */;

	--pagination-nav-color: #{$buttonPrimaryColor}/* property value */;
	--pagination-nav-background: #{$lightGray} /* property value */;
	--pagination-nav-hover-color: #{$buttonPrimaryColorHover} /* property value */;
	--pagination-nav-hover-background: #{$buttonPrimaryBackgroundHover} /* property value */;
	--pagination-nav-disabled-opacity: /* property value */;
	--pagination-nav-transition: 0.25s ease/* property value */;

	--pagination-number-color: /* property value */;
	--pagination-number-background: /* property value */;
	--pagination-number-hover-color: /* property value */;
	--pagination-number-hover-background: /* property value */;
	--pagination-number-active-color: /* property value */;
	--pagination-number-active-background: /* property value */;
	--pagination-number-transition: /* property value */;

	max-width: 72rem;
	margin: 3rem auto 1rem;
	@include mqdn(md_dn) {
		margin: 2rem auto 1rem;
	}

	.search-filters {
		&__toggle {
			@include btn($tertiary: true);
			margin: 1.25rem 0;
			@include mq(lg) {
				display: none;
			}
		}
		&__btn {
			@include btn($secondary: true);
		}
		&-group {
			&__title {
				font-family: $fontFamilySerif;
				font-weight: 500;
				font-style: italic;
				font-size: 1.125rem; 
			}
		}
		&-item {
			&__label {
				span {
					font-weight: 500;
				}
			}
		}
	}
	.search__results {
		gap: unset;
	}
	.search-result {
		&__content {

		}
		&__img {
			display: none;
		}
	}
	.search-pagination {
		&__number {
			font-size: 1rem;
		}
		&__prev,
		&__next {
			height: 2rem;
			// little magic numbery here
			position: relative;
				top: -.2em;
			width: 2rem;
			&:after{
				@include fgIcon();
				content: '\003c';
				border: none;
				height: auto;
				transform: none;
				width: auto;
			}
		}
		&__next {
			&:after {
				content: '\003e';
			}
		}
	}
	.search {
		&__layout {
			grid-template-columns: 60fr minmax(16rem, 35fr);
			grid-template-areas:
				"head rail"
				"main rail"
				"foot rail";
			gap: 0.5rem 4rem;
		}
		&__main {
			grid-area: main;
		}
		&__footer {
			grid-area: foot;
		}
	}
}
</style>
